export default function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// /home/calculadorareforma/domains/calculadorareforma.plug-in.es/public_html/wp-content/themes/templatePLG/node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
// module id = 141
// module chunks = 0